<template>
  <div class="wrapper">
    <app-header />
    <!-- second nav start -->
    <div class="second-nav w-100 d-flex flex-row align-items-center">
      <div class="container">
        <div class="d-flex m-0 flex-row align-items-center nav-links">
          <a class="">info Detail </a>
          <a class=""><i class="fas fa-angle-double-right"></i>Life Area </a>
          <a class="active"><i class="fas fa-angle-double-right"></i>{{lifearea}} </a>
        </div>
      </div>
    </div>
    <!-- end of second nav -->
    <!-- page middle conntent -->
    <div class="container">
        <div class="row score_div">
            <h4>Congratulations!</h4>
            <span>You have completed {{lifearea}} quiz!</span>
        </div>
      <div v-if="lifearea_id === 1">
        <div class="row graph" >
          <div class ="col-sm-2" style="margin-top: 10%;">Original Score {{format_date(preTestDate)}}</div>
          <div class="col-md-2">
              <div class="row">
                <span style="margin-left: -8px;" class="heading_span">Self Efficiency</span>
              </div>
              <div class="row">
            <CircleProgress
              :percent="score_one"
              :viewport="true"
              :show-percent="true"
              :is-gradient="true"
              :maxPercent="100"
              :gradient="{
                angle: 90,
                startColor: '#2c84c4',
                stopColor: '#6eb44e',
              }"
              :size="140"
            /></div>
          </div>
          <div class="col-md-2">
              <div class="row">
                <span style="margin-left: -16px;" class="heading_span">Self-Esteem</span>
              </div>
              <div class="row">
            <CircleProgress
              :percent="score_two"
              :viewport="true"
              :show-percent="true"
              :is-gradient="true"
              :maxPercent="100"
              :gradient="{
                angle: 90,
                startColor: '#2c84c4',
                stopColor: '#6eb44e',
              }"
              :size="140"
            /></div>
          </div>
          <div class="col-md-2">
              <div class="row">
                <span style="margin-left: -17px;" class="heading_span">Anxiety</span>
              </div>
              <div class="row">
            <CircleProgress
              :percent="score_three"
              :viewport="true"
              :show-percent="true"
              :is-gradient="true"
              :maxPercent="100"
              :gradient="{
                angle: 90,
                startColor: '#2c84c4',
                stopColor: '#6eb44e',
              }"
              :size="140"
            /></div>
          </div>
          <div class="col-md-2">
              <div class="row">
                <span class="heading_span" style="margin-left: -10px;">Depression</span>
              </div>
              <div class="row">
            <CircleProgress
              :percent="score_four"
              :viewport="true"
              :show-percent="true"
              :is-gradient="true"
              :maxPercent="100"
              :gradient="{
                angle: 90,
                startColor: '#2c84c4',
                stopColor: '#6eb44e',
              }"
              :size="140"
            /></div>
          </div>
        </div>
        <div class="row graph" >
          <div class ="col-sm-2" style="margin-top: 10%;">Score {{format_date(postTestDate)}}</div>
          <div class="col-md-2">
              <div class="row">
                <span style="margin-left: -8px;" class="heading_span">Self Efficiency</span>
              </div>
              <div class="row">
            <CircleProgress
              :percent="score_post_one"
              :viewport="true"
              :show-percent="true"
              :is-gradient="true"
              :maxPercent="100"
              :gradient="{
                angle: 90,
                startColor: '#2c84c4',
                stopColor: '#6eb44e',
              }"
              :size="140"
            /></div>
          </div>
          <div class="col-md-2">
              <div class="row">
                <span style="margin-left: -16px;" class="heading_span">Self-Esteem</span>
              </div>
              <div class="row">
            <CircleProgress
              :percent="score_post_two"
              :viewport="true"
              :show-percent="true"
              :is-gradient="true"
              :maxPercent="100"
              :gradient="{
                angle: 90,
                startColor: '#2c84c4',
                stopColor: '#6eb44e',
              }"
              :size="140"
            /></div>
          </div>
          <div class="col-md-2">
              <div class="row">
                <span style="margin-left: -17px;" class="heading_span">Anxiety</span>
              </div>
              <div class="row">
            <CircleProgress
              :percent="score_post_three"
              :viewport="true"
              :show-percent="true"
              :is-gradient="true"
              :maxPercent="100"
              :gradient="{
                angle: 90,
                startColor: '#2c84c4',
                stopColor: '#6eb44e',
              }"
              :size="140"
            /></div>
          </div>
          <div class="col-md-2">
              <div class="row">
                <span class="heading_span" style="margin-left: -10px;">Depression</span>
              </div>
              <div class="row">
            <CircleProgress
              :percent="score_post_four"
              :viewport="true"
              :show-percent="true"
              :is-gradient="true"
              :maxPercent="100"
              :gradient="{
                angle: 90,
                startColor: '#2c84c4',
                stopColor: '#6eb44e',
              }"
              :size="140"
            /></div>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="row graph">
          <div class ="col-sm-2" style="margin-top: 10%;">Original Score {{format_date(preTestDate)}}</div>
          <div class="col-md-3">
            <div class="row">
              <span class="heading_span">{{lifearea}}</span>
            </div>
            <div class="row">
              <CircleProgress
                :percent="score"
                :viewport="true"
                :show-percent="true"
                :is-gradient="true"
                :maxPercent="100"
                :gradient="{
                  angle: 90,
                  startColor: '#2c84c4',
                  stopColor: '#6eb44e',
                }"
                :size="140"
              />
            </div>
          </div>
        </div>
        <div class="row graph">
          <div class ="col-sm-2" style="margin-top: 10%;">Score {{format_date(postTestDate)}}</div>
          <div class="col-md-3">
            <div class="row">
              <span class="heading_span">{{lifearea}}</span>
            </div>
            <div class="row">
              <CircleProgress
                :percent="post_score"
                :viewport="true"
                :show-percent="true"
                :is-gradient="true"
                :gradient="{
                  angle: 90,
                  startColor: '#2c84c4',
                  stopColor: '#6eb44e',
                }"
                :size="140"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="row" style="margin-top: 4%;">
        <div class="info-form-btns  col-sm-12 mx-auto text-center">
          <router-link to="success">
            <button class="info-continue-btn ">Continue</button></router-link>
        </div>
      </div>
    </div>
    <!--Footer start-->
    <app-footer />
    <!--Footer end-->
  </div>
</template>
<style scoped>
@import "./../assets/css/style_new.css";
.score_div {
  margin-top: 4%;
}
.graph{
  margin-top: 5%;
  margin-left: 10%;
}
.heading_span{
    margin-left: -27%;
    color: #2c84c4;
    margin-bottom: 8%;
}
span.current-counter::after {
  content: "%";
}
</style>
<script>
import AppFooter from '@/components/AppFooter.vue'
import AppHeader from '@/components/AppHeader.vue'
import 'vue3-circle-progress/dist/circle-progress.css'
import CircleProgress from 'vue3-circle-progress'
import axios from 'axios'
import moment from 'moment'
export default {
  components: {
    AppFooter,
    AppHeader,
    CircleProgress
  },
  data () {
    return {
      score_one: 0,
      score_two: 0,
      score_three: 0,
      score_four: 0,
      score_post_one: 0,
      score_post_two: 0,
      score_post_three: 0,
      score_post_four: 0,
      score: 0,
      post_score: 0,
      lifearea_id: 0,
      lifearea: '',
      base_url: '',
      preTestDate: '',
      postTestDate: '',
      tests: [],
      currentLifearea: 0,
      lifearea_id_one: 0,
      lifearea_id_two: 0,
      token: '',
      currentId: ''
    }
  },
  methods: {
    async getUserDetails () {
      this.user_id = localStorage.getItem('user_id')
      this.base_url = process.env.VUE_APP_WEBAPP_URL
      this.token = localStorage.getItem('api_token')
      const response = await axios.get(this.base_url + '/session/getCurrentTest/', {
        headers: {
          Authorization: 'Bearer ' + this.token
        }
      })
      console.log('response getcurrenttest ===', response.data.data.lifearea_id)
      localStorage.setItem('currentLifeArea', response.data.data.lifearea_id)
      this.currentId = localStorage.getItem('current_lifearea_name')
      console.log(this.currentId)
      if (this.currentId === '1') {
        this.lifearea = 'Self'
      } else if (this.currentId === '2') {
        this.lifearea = 'Friends'
      } else if (this.currentId === '3') {
        this.lifearea = 'Career'
      } else if (this.currentId === '4') {
        this.lifearea = 'Finances'
      } else if (this.currentId === '5') {
        this.lifearea = 'Romantic Relationship'
      } else {
        this.lifearea = 'Family'
      }
      const responseData = await axios.get(this.base_url + '/session/getTests/', {
        headers: {
          Authorization: 'Bearer ' + this.token
        }
      })
      this.currentLifearea = parseInt(localStorage.getItem('currentLifeArea'))
      console.log(responseData.data.data.tests)
      console.log(typeof this.currentLifearea)
      this.lifearea_id_one = responseData.data.data.tests[1].lifearea_id
      this.lifearea_id_two = responseData.data.data.tests[2].lifearea_id
      if (this.lifearea_id_one === this.currentLifearea) {
        console.log('jhjd')
        this.lifearea_id = responseData.data.data.tests[0].lifearea_id
        console.log(this.lifearea_id)
      } else if (this.lifearea_id_two === this.currentLifearea) {
        console.log('sfgs')
        this.lifearea_id = responseData.data.data.tests[1].lifearea_id
        console.log(this.lifearea_id)
      }
    },
    async getTest () {
      this.user_id = localStorage.getItem('user_id')
      this.base_url = process.env.VUE_APP_WEBAPP_URL
      this.token = localStorage.getItem('api_token')
      const responseData = await axios.get(this.base_url + '/session/getTests/', {
        headers: {
          Authorization: 'Bearer ' + this.token
        }
      })
      this.currentLifearea = parseInt(localStorage.getItem('currentLifeArea'))
      console.log(responseData.data.data.tests)
      // console.log(typeof this.currentLifearea)
      this.lifearea_id_one = responseData.data.data.tests[1].lifearea_id
      this.lifearea_id_two = responseData.data.data.tests[2].lifearea_id
      if (this.lifearea_id_one === this.currentLifearea) {
        // console.log('jhjd')
        this.lifearea_id = responseData.data.data.tests[0].lifearea_id
        console.log(this.lifearea_id)
      } else if (this.lifearea_id_two === this.currentLifearea) {
        // console.log('sfgs')
        this.lifearea_id = responseData.data.data.tests[1].lifearea_id
        console.log(this.lifearea_id)
      }
      if (this.lifearea_id === 1) {
        this.lifearea = 'Self'
      } else if (this.lifearea_id === 2) {
        this.lifearea = 'Friends'
      } else if (this.lifearea_id === 3) {
        this.lifearea = 'Career'
      } else if (this.lifearea_id === 4) {
        this.lifearea = 'Finances'
      } else if (this.lifearea_id === 5) {
        this.lifearea = 'Romantic Relationship'
      } else if (this.lifearea_id === 6) {
        this.lifearea = 'Family'
      }
    },
    format_date (value) {
      if (value) {
        return moment(String(value)).format('DD/MM/YYYY')
      }
    }
  },
  mounted: function () {
    this.score_post_one = this.$store.state.post_score_one
    this.score_post_two = this.$store.state.post_score_two
    this.score_post_three = this.$store.state.post_score_three
    this.score_post_four = this.$store.state.post_score_four
    this.score_one = this.$store.state.self_score_one
    this.score_two = this.$store.state.self_score_two
    this.score_three = this.$store.state.self_score_three
    this.score_four = this.$store.state.self_score_four
    this.score = this.$store.state.score
    this.post_score = this.$store.state.post_score
    this.postTestDate = this.$store.state.postTestDate
    this.preTestDate = this.$store.state.pretestDate
    console.log(this.postTestDate)
    console.log(this.preTestDate)
    this.getUserDetails()
    this.getTest()
  }
}
</script>
